import ReservationHistory from "./ReservationHistory";

class ReservationHistories {
  constructor(private readonly _list: ReservationHistory[] = []) {
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList(): ReservationHistory[] {
    return this._list;
  }
}

export default ReservationHistories;
